var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line 10",
    d: "M27.6051 8.70711C27.9956 8.31658 27.9956 7.68342 27.6051 7.29289L21.2411 0.928932C20.8506 0.538408 20.2174 0.538408 19.8269 0.928932C19.4364 1.31946 19.4364 1.95262 19.8269 2.34315L25.4837 8L19.8269 13.6569C19.4364 14.0474 19.4364 14.6805 19.8269 15.0711C20.2174 15.4616 20.8506 15.4616 21.2411 15.0711L27.6051 8.70711ZM1.89795 7C1.34566 7 0.897949 7.44772 0.897949 8C0.897949 8.55228 1.34566 9 1.89795 9V7ZM26.8979 7L1.89795 7V9L26.8979 9V7Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7d8b2515aee01363c60a72cddb2a4aac.svg";
export { ForwardRef as ReactComponent };